import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import {
  LoadingController,
  MenuController,
  PopoverController,
} from "@ionic/angular";
import { lastValueFrom } from "rxjs";
import {
  AuditTrailService,
  AuthenticationService,
} from "src/app/services/swagger";
import { TenantStorageService } from "src/app/services/token-auth/tenant-storage.service";
import { TokenStorageService } from "src/app/services/token-auth/token-storage.service";
import { UserDataService } from "src/app/services/user/user.service";
import { ROUTES } from "src/app/utils/routes";

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
})
export class DropdownComponent implements OnInit {
  isMultiTenant: boolean = false;

  ROUTES = ROUTES;
  constructor(
    private menu: MenuController,
    private authenticationService: AuthenticationService,
    private auditTrailService: AuditTrailService,
    private popoverController: PopoverController,
    public userService: UserDataService,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private tenantStorageService: TenantStorageService,
    private loadingCtrl: LoadingController
  ) {}

  async ngOnInit() {
    let tenants = await this.userService.getMultiTenants();
    if (tenants && tenants.tenantProfiles && tenants.tenantProfiles.length) {
      this.isMultiTenant = true;
    } else {
      this.isMultiTenant = false;
    }
  }

  dismissPopover() {
    this.popoverController.dismiss();
  }

  async logout() {
    let user = await this.userService.getCurrentUser();
    let loading = await this.loadingCtrl.create({ message: "loading..." });
    this.dismissPopover();
    this.close();
    await loading.present();
    try {
      await lastValueFrom(
        this.auditTrailService.apiAudittrailInsertPost({
          auditTrailEventInsertModel: {
            auditTrailActionId: 2,
            auditTrailTypeId: 1,
            auditTrailNotes: `User ${user.userName} logout from account name ${user.companyName}`,
          },
        })
      );
      await this.userService.logout();
      await this.router.navigateByUrl(ROUTES.LOGIN_PAGE);
      await loading.dismiss();
    } catch (e) {
      await this.userService.logout();
      await this.router.navigateByUrl(ROUTES.LOGIN_PAGE);
      await loading.dismiss();
      throw e;
    }
  }

  async switchCompany() {
    let user = await this.userService.getCurrentUser();
    let loading = await this.loadingCtrl.create({ message: "loading..." });
    await loading.present();
    try {
      this.dismissPopover();
      this.close();
      await lastValueFrom(
        this.auditTrailService.apiAudittrailInsertPost({
          auditTrailEventInsertModel: {
            auditTrailActionId: 2,
            auditTrailTypeId: 1,
            auditTrailNotes: `User ${user.userName} logout from account name ${user.companyName}`,
          },
        })
      );
      if (Capacitor.getPlatform() === "web") {
        this.userService.isNotGoToLogin = true;
        this.userService.isNotResetUser = true;
        this.userService.token = null;
        await this.userService.getAuthorizeUrl();
        await this.tokenStorage.setToken(null);
        await this.tenantStorageService.setTenants(null);
        await loading.dismiss();
      } else {
        this.userService.token = null;
        let res =
          await this.authenticationService.apiAuthenticationAuthorizationURLGet(
            {
              isApp: true,
            }
          );
        let result = await lastValueFrom(res);
        await Browser.open({
          url: result.url,
        });
        App.addListener("appUrlOpen", async ({ url }) => {
          if (url) {
            const params = new URL(url);
            const code = params.searchParams.get("code");
            const sessionState = params.searchParams.get("session_state");
            const state = params.searchParams.get("state");
            if (code && sessionState && state) {
              await this.userService.logout();
              await this.router.navigateByUrl(ROUTES.LOGIN_PAGE);
              setTimeout(async () => {
                await this.router.navigate([ROUTES.CALLBACK_MOBILE_PAGE], {
                  queryParams: {
                    code: code,
                    session_state: sessionState,
                    state: state,
                  },
                });
              }, 1000);
            }
          }
          await Browser.close();
          await loading.dismiss();
        });
      }
    } catch (e) {
      await loading.dismiss();
      throw e;
    }
  }

  async profile() {
    this.dismissPopover();
    this.close();
    await this.router.navigateByUrl("profile");
  }

  close() {
    this.menu.close();
  }
}
